import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Task, TaskLevel } from '../../../entities/Task';
import { IMyDpOptions } from 'mydatepicker';
import { AppConfig } from '../../../app.config';
import { MaintenanceColorCodes } from '../../../services/converter.service';
import { SessionService } from 'app/services/session.service';

declare var $: any;

@Component({
  selector: 'app-task-overview-view',
  templateUrl: './task-overview-view.component.html',
  styleUrls: ['./task-overview-view.component.css'],
})
export class TaskOverviewViewComponent implements OnInit, AfterViewInit {

  maintenanceColorCodes = MaintenanceColorCodes;

  @Input('tasks')
  set Tasks(value: Task[]) {
    this.tasks = value ? [...value] : [];
    setTimeout(() => this.updateScrollHeight(), 0);
  }

  @Input('companies')
  set Companies(companies: any[]) {
    this.companies = companies;
  }

  @Input('screenHeightInPx')
  set ScreenHeight(screenHeightInPx: number) {
    this.screenHeight = screenHeightInPx;
    this.updateScrollHeight();
  }

  @Output()
  refreshDataEmitter = new EventEmitter();
  @Output()
  createNotificationEmitter = new EventEmitter();
  @Output()
  chooseTaskEmitter = new EventEmitter();
  @Output()
  updateTaskEmitter = new EventEmitter();
  @Output()
  updateActivitiesEmitter = new EventEmitter();

  public orderParameter = 'No';
  public sortReverse = false;
  public searchInput = '';
  tasks: Task[] = [];
  currentProductModel: any;
  chosenNotification: any;
  loggedInUserNo: string;
  loading = false;
  companies: any[];
  heightStyle: any = {};
  private screenHeight = 0;
  @ViewChild('taskOverviewScroll') taskOverviewScroll: ElementRef;

  /** Date navigation **/
  public StartDate;
  public EndDate;
  public dummyStart;
  public dummyEnd;

  public startDatePickerOptions: IMyDpOptions;
  public endDatePickerOptions: IMyDpOptions;

  constructor(private appConfig: AppConfig, public sessionService: SessionService) { }

  ngOnInit() {
    this.loggedInUserNo = sessionStorage.getItem('loggedInUserNo');
    this.currentProductModel = this.appConfig.getConfig('productModel');
  }

  ngAfterViewInit() {
    this.updateScrollHeight();
  }

  setOrderParameter(para: string) {
    if (this.orderParameter === para) {
      this.sortReverse = !this.sortReverse;
    }
    this.orderParameter = para;
  }

  openCreateModal() {
    setTimeout(() => {
      $('#createNotificationModal').modal('show');
    }, 50);
  }

  createNotificationAndClose(notification) {
    this.loading = true;
    this.createNotificationEmitter.emit(notification);
    $('#createNotificationModal').modal('hide');
  }

  chooseTask(task: Task) {
    this.chooseTaskEmitter.emit(task);
  }

  trackByTask(index: number, task: Task) {
    return task && (task.Task_GUID || task.No || index);
  }

  getTaskTitle(task: Task): string {
    return task && (task.Title || task.Text || task.Maintenance_Object || '');
  }

  getTaskSubtitle(task: Task): string {
    if (!task) {
      return '';
    }

    const title = this.getTaskTitle(task);

    if (task.Maintenance_Object && task.Maintenance_Object !== title) {
      return task.Maintenance_Object;
    }

    return task.App_Task_Category_Description || task.Shortcut_Dimension_2_Name || '';
  }

  getTaskResponsibleName(task: Task): string {
    if (!task) {
      return '';
    }

    return this.isSelectedCompanyOTS
      ? task.OTS_Responsible_Name || task.OTS_Responsible || ''
      : task.Responsible_Name || task.Responsible || '';
  }

  getStatusTranslationKey(status: string): string {
    return status ? status.replace(/\s+/g, '') : '';
  }

  getPriorityTranslationKey(priority: string): string {
    if (!priority) {
      return 'Normal';
    }

    const normalized = priority.toString().toLowerCase();
    return normalized === 'critical' || normalized === '1' ? 'Critical' : 'Normal';
  }

  get isSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateScrollHeight();
  }

  private updateScrollHeight() {
    if (this.taskOverviewScroll && this.taskOverviewScroll.nativeElement) {
      const topOffset = this.taskOverviewScroll.nativeElement.getBoundingClientRect().top;
      const availableHeight = Math.max(0, window.innerHeight - topOffset - 8);
      this.heightStyle = {
        height: `${availableHeight}px`,
        boxSizing: 'border-box'
      };
      return;
    }

    if (this.screenHeight > 0) {
      this.heightStyle = {
        height: `${Math.max(0, this.screenHeight - 250)}px`,
        boxSizing: 'border-box'
      };
    }
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/task-overview/task-overview-view.component.ts